<template>
    <transition name="fade">
        <div class="notification-popup" :class="{'is-show-cookies': is_show_cookies}">
            <div class="box">
                <div class="text" v-html="$store.state.notification.text"></div>
                <div class="close-btn"><Button @click.native="close" :size="'small'">Close</Button></div>
            </div>
        </div>
    </transition>
</template>

<script>
import Button from '@/components/ui/Button.vue';

export default {
    name: 'notification',
    components: {
        Button,
    },

    props: {
        is_show_cookies: {
            type: Boolean,
            default: false,
        },

    },
    // data() {
    //     return {
    //         is_open: true,
    //     }
    // },
    methods: {
        close() {
            // window.localStorage.setItem('hide_cookies', 1);
            this.$store.state.notification.is_show = false;
        },
    },

}
</script>

<style lang="scss">

    .fade-enter-active, .fade-leave-active {
        opacity: 1;
        transition: opacity .3s ease-in-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .notification-popup {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 999;
        padding: var(--padding) var(--padding) var(--padding-50);
        background: var(--theme-1-color-1);
        box-sizing: border-box;
        width: 100%;
        color: black;

        &.is-show-cookies {
            bottom: 7rem;
        }

        .box {
            display: flex;
            flex-wrap: wrap;

            .text {
                padding-right: var(--padding);
                padding-bottom: var(--padding-50);
            }
        }

        .ui-button {
            cursor: pointer;
            color: black;
            border-color: black;

            &:hover {
                background: black;
                color: white;
            }
        }
    }

</style>
